import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";
import Loader from "../../Components/Common/Loader";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_MENU_OPTIMIZATION } from "../../helpers/data_helper";
import {
  getDateByName,
  convertDateFormate,
  currencyFormatWithAlert,
} from "../../helpers/api_helper";

const FoodTribesChart = ({ leftFilter, rightFilter, leftCustomDate, mealPeriod, currency, defaultCourse, comparisonDate, activeComparisonData }) => {
  const [foodTribeData, setFoodTribeData] = useState({
    Covers: [],
    AvgCheck: [],
    CourseName: [],
    Courses: {},
  });
  const [foodTribeAjax, setFoodTribeAjax] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalAjax, setModalAjax] = useState(false);

  var chartLineColumnColors = getChartColorsArray(
    '["--vz-primary", "--vz-danger", "--vz-success", "--vz-warning"]'
  );

  const courseNameToIdMap = useMemo(() => {
    const m = {};
    const courses = foodTribeData.Courses || {};
    Object.entries(courses).forEach(([id, name]) => {
      m[name] = id;
    });
    return m;
  }, [foodTribeData.Courses]);

  const fooedTribesSeries = [
    {
      name: "Avg Check",
      type: "line",
      data: foodTribeData["AvgCheck"],
    },
    {
      name: "Item Sold",
      type: "column",
      data: foodTribeData["Covers"],
    },
  ];
  let chartLineColumnYaxis = [
    {
      title: {
        seriesName: "Avg Check",
        text: "Avg Check",
        style: {
          fontWeight: 600,
        },
      },
      labels: {
        formatter: function (value) {
          return value.toFixed(0);
        },
      },
    },
    {
      opposite: true,
      seriesName: "Item Sold",
      title: {
        text: "Item Sold",
        style: {
          fontWeight: 600,
        },
      },
      decimalsInFloat: 0,
    },
  ];

  if (foodTribeData["AvgCheckPY"]) {
    fooedTribesSeries.push({
      name: "Avg Check PY",
      type: "line",
      data: foodTribeData["AvgCheckPY"],
    });
    chartLineColumnYaxis.push({
      title: {
        seriesName: "Avg Check",
      },
      show: false,
    });
  }
  if (foodTribeData["CoversPY"]) {
    fooedTribesSeries.push({
      name: "Covers PY",
      type: "column",
      data: foodTribeData["CoversPY"],
    });
    chartLineColumnYaxis.push({
      title: {
        seriesName: "Item Sold",
      },
      show: false,
    });
  }
  const fooedTribesOptions = {
    chart: {
      toolbar: {
        show: true,
      },
      events: {
        dataPointSelection: function (event, chartContext, config) {
          const { dataPointIndex } = config;

          if (dataPointIndex === -1) return;

          const courseName = foodTribeData.CourseName[dataPointIndex];
          const courseId = courseNameToIdMap[courseName];

          if (courseId) {
            setTimeout(() => handleDataPointClick(courseId), 0);
          }
        },
        click: function (event, chartContext, config) {
          // Handle clicks on X-axis labels
          try {
            const target = event.target;
            // Check if clicked on text element (label)
            if (target && (target.tagName === 'text' || target.tagName === 'tspan')) {
              const text = target.textContent?.trim();
              if (text && foodTribeData.CourseName.includes(text)) {
                const dataPointIndex = foodTribeData.CourseName.indexOf(text);
                const courseId = courseNameToIdMap[text];
                if (courseId) {
                  handleDataPointClick(courseId);
                }
              }
            }
          } catch (err) {
            // Silently fail for non-label clicks
            console.error(err);
          }
        },
      }
    },
    stroke: {
      width: [4, 0, 4, 0],
      curve: "smooth",
    },
    title: {
      text: "",
    },
    dataLabels: {
      enabled: true,
      formatter: function (value, { seriesIndex, dataPointIndex, w }) {
        return value;
      },
    },
    labels: foodTribeData["CourseName"],
    xaxis: {
      type: "category",
    },
    yaxis: chartLineColumnYaxis,
    colors: chartLineColumnColors,
    plotOptions: {
      bar: {
        columnWidth: "40%",
      },
    },
    tooltip: {
      y: {
        formatter: function (value, { seriesIndex }) {
          // Check the seriesIndex to format the value accordingly
          if (seriesIndex === 0) {
            return value.toFixed(2);
          } else {
            return value;
          }
        },
      },
    },
  };

  const handleDataPointClick = (courseId) => {
    let leftFilterData =
      leftFilter.value === "Custom"
        ? {
            from: convertDateFormate(leftCustomDate[0]),
            to: convertDateFormate(leftCustomDate[1]),
          }
        : getDateByName(leftFilter.value);
    setModal(true);
    setModalAjax(true);
    postDataAPI({
      course: courseId,
      dateFilter: leftFilterData,
      serviceName: "menu_data",
      op: "get_items_under_tribe",
    }).then((response) => {
      setModalAjax(false);
      if (response.status === "ok") {
        setModalData(response?.data);
      } else {
        console.log(response);
      }
    });
  };

  useEffect(() => {
    if (
      (leftFilter.value !== "Custom" ||
        (leftFilter.value === "Custom" &&
          leftCustomDate[0] &&
          leftCustomDate[1])) &&
      (rightFilter.value !== "Custom" ||
        (rightFilter.value === "Custom" &&
          comparisonDate[0] &&
          comparisonDate[1]))
    ) {
      let leftFilterData =
        leftFilter.value === "Custom"
          ? {
            from: convertDateFormate(leftCustomDate[0]),
            to: convertDateFormate(leftCustomDate[1]),
          }
          : getDateByName(leftFilter.value);
      let rightFilterData =
        activeComparisonData && activeComparisonData.datepiker
          ? {
            from: convertDateFormate(comparisonDate[0]),
            to: convertDateFormate(comparisonDate[1]),
          }
          : getDateByName(rightFilter.value);
      setFoodTribeAjax(true);
      const controller = new AbortController();    
      postDataAPI({
        leftFilter: leftFilterData,
        rightFilter: rightFilterData,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.food_tribes_op,
      }, controller.signal).then((response) => {
        setFoodTribeAjax(false);
        if (response.status === "ok") {
          setFoodTribeData(response.data);
        } else {
          console.log(response);
        }
      });
      return () => {
          controller.abort();
      };
    }
  }, [
    leftFilter,
    rightFilter,
    mealPeriod,
    comparisonDate,
    activeComparisonData,
    leftCustomDate,
    defaultCourse,
  ]);

  return (
    <>
    <Card>
      <CardHeader>
        <div className="d-flex align-items-start">
          <div className={`icon-box rounded bg-danger text-white`}>
            <i className="ri-bar-chart-fill"></i>
          </div>
          <div className="ps-2">
            <h4 className="card-title mb-1">
              Food Tribes
            </h4>
            <p className="text-muted mb-0">
              Category-level view of items sold and their average check contribution.
            </p>
          </div>
        </div>        </CardHeader>
      <CardBody>
        {foodTribeAjax && <Loader />}
        <div id="FoodTribesChart" className={foodTribeAjax ? "opacity-0" : ""}>
          <ReactApexChart
            options={fooedTribesOptions}
            series={fooedTribesSeries}
            type="line"
            height={350}
          />
        </div>
      </CardBody>
    </Card>
    <Modal
      className="modal-dialog modal-xl custom-bg"
      isOpen={modal}
      toggle={() => setModal(false)}
      id="fullscreeexampleModal"
    >
      <ModalHeader className="modal-title" id="exampleModalFullscreenLabel" toggle={() => setModal(false)}>
        {modalData[0]?.cfv_display_name}
      </ModalHeader>
      <ModalBody>
        <Card style={{ borderRadius: '8px', padding: '15px' }}>
          <CardBody>
            {modalAjax && <Loader />}
            {!modalAjax && modalData?.length > 0 && (
            <div className="table-responsive table-card" style={{ maxHeight: '500px', overflow: 'auto' }}>
            <table className="table table-borderless table-centered align-middle table-nowrap mb-3 text-center">
              <thead className="text-muted table-light">
                <tr style={{ position: 'sticky', top: -2, zIndex: 100 }}>
                  <th scope="col" className="text-start">Item Name</th>
                  <th scope="col">Performance Group</th>
                  <th scope="col">Item Sold</th>
                  <th scope="col">Avg Check</th>
                  <th scope="col">Revenue</th>
                </tr>
              </thead>
              <tbody>
                {modalData?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-start" >
                      <b>{item.item_name}</b>
                    </td>
                    <td>
                      <span
                            className={`badge bg-${
                                item.performance_group === "Plowhorse"
                                  ? "warning"
                                  : item.performance_group === "Dog"
                                    ? "danger"
                                    : item.performance_group === "Cash Cow"
                                      ? "warning"
                                      : item.performance_group === "Puzzle"
                                        ? "light text-dark"
                                        : "success"
                              }
                              `}
                            >
                              {item.performance_group}
                      </span>
                    </td>
                    <td>
                      {item.item_sold}
                    </td>
                    <td>{currencyFormatWithAlert((item.total_sales / item.item_sold), currency)}</td>
                    <td>{currencyFormatWithAlert(item.total_sales, currency)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
            )}
            {!modalAjax && modalData?.length === 0 && (
              <p>No data available</p>
          )}
        </CardBody>
       </Card>
      </ModalBody>
    </Modal>
    </>
  );
};

export default FoodTribesChart;
